import { onMounted, ShallowRef, shallowRef, watch } from 'vue';
import { mtsEmitter } from '@mts/utils';
import { createApi } from '@/api';

const apiCountCache = new Map<string, Recordable>();
export function useCountMap(
  countApi: string | undefined,
  options: ShallowRef<{ value: unknown }[]>,
  countField: string,
) {
  const countMap = shallowRef<Recordable<number>>({});
  const apiParams = shallowRef<Recordable>({ search: {} });

  const fetchCountMap = () => {
    if (!countApi || !options.value.length) return;

    const countFieldEnum = options.value.map((i) => i.value).filter(Boolean);
    createApi(countApi)({
      ...apiParams.value,
      summaryCount: { countField, countFieldEnum },
    }).then((res) => {
      countMap.value = res;
      apiCountCache.set(countApi + countField, res);
    });
  };

  onMounted(() => {
    if (!countApi) return;

    const latestParams = sessionStorage.getItem('table-fetch-latest-params');
    if (latestParams) {
      apiParams.value = JSON.parse(latestParams);
      watch(options, fetchCountMap, { once: true });
    }

    mtsEmitter.on('tableFetch', (params) => {
      apiParams.value = params;
      fetchCountMap();
    });

    const cacheValue = apiCountCache.get(countApi + countField);
    if (cacheValue) {
      countMap.value = cacheValue;
    }
  });

  const getCountNum = (valueKey: string | number, onlyNum?: boolean) => {
    if (!countApi) return '';

    const num = countMap.value[valueKey || 'total'] || 0;
    return onlyNum ? num : `(${num})`;
  };

  return { getCountNum, fetchCountMap };
}
